export class PermissionGroupRow {
    public id: number;
    public name: string;
    public description: string;
    public members: string;
}

export class PermissionGroup {
    public id: number;
    public systemId: string;
    public name: string;
    public description: string;
    public condition: string;
    public selectedPermissions: SelectedPermissions;
    public logic: PermissionGroupLogic;

    constructor() {
        this.selectedPermissions = new SelectedPermissions();
    }
}

export class SelectedPermissions {
    public manualPermissions: Array<number>;
    public companyPermissions: Array<number>;
    public marketPermissions: Array<number>;
    public salesOrgPermissions: Array<number>;
    public multiBrandingPermissions: Array<number>;
    public userTypePermissions: Array<number>;
    public users: Array<number>; 

    constructor() {
        this.manualPermissions = new Array<number>();
        this.companyPermissions = new Array<number>();
        this.marketPermissions = new Array<number>();
        this.salesOrgPermissions = new Array<number>();
        this.multiBrandingPermissions = new Array<number>();
        this.userTypePermissions = new Array<number>();
        this.users = new Array<number>();
    }
}

export enum PermissionType {
    ManualyCreated,
    UserType,
    Company,
    Market,
    Multibranding,
    Users,
    SalesOrganization
}

export class SelectedPermissionVM {
    public id: number;
    public permissions = new Array<number>();
}

export enum PermissionGroupLogic {
    AND = 0,
    OR = 1
}
